import { createModalContext } from '@flote/app-core/modal';
import { ModalType, type ModalPropsMap } from './modal-types';

const { ModalProvider, useModal, ModalContext } = createModalContext<ModalType, ModalPropsMap>();

export { ModalProvider, useModal, ModalContext, ModalType };
export type { ModalPropsMap };
